import React from 'react'
import Modal from '../../../../../components/Modal'

const ModalResolveDivergence = ({ children, show, title, action }) => (
  <Modal
    show={show}
    title={title}
    closeButtonAction={action}
    body={children}
    testId='modal-resolve-divergence-test-id'
  />
)

export { ModalResolveDivergence }
